export const MODAL_CLOSE_ANIMATION_MS = 220
export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024
export const ACCEPTED_UPLOAD_TYPES =
  'image/*,.csv,text/csv,.tsv,.json,application/json,.txt,text/plain,.log,.pdf,application/pdf'
export const MIN_MESSAGE_LENGTH = 5
